import React, { Fragment } from 'react';

import PropTypes from 'prop-types';

import CrumbText from './CrumbText';

const CrumbLink = ({ icon, text, varText, parentIndex, ...rest }) => (
  <Fragment>
    {parentIndex ? (
      <span
        // @Note: Passing the Crumb to Stencil, send a literal onclick attribute
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `
            <a class="cr-topbar__crumb-link" onClick="returnToParentX('view', ${parentIndex});">
              ${text ? `<span>${text}</span>` : ''}
              ${varText ? `<var> ${varText}</var>` : ''}
            </a>
          `,
        }}
      />
    ) : (
      <a className="cr-topbar__crumb-link" {...rest}>
        <CrumbText text={text} icon={icon} varText={varText} />
      </a>
    )}
  </Fragment>
);

CrumbLink.propTypes = {
  icon: PropTypes.node,
  text: PropTypes.node,
  varText: PropTypes.node,
  parentIndex: PropTypes.number,
};

export default CrumbLink;
